import React, { Component } from "react";
import ReactCSSTransitionReplace from "react-css-transition-replace";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { StepHistory } from "components/Steps";
import Logo from "components/Logo";
import Cart from "components/Cart";

import { Type, Size, Style, RoofMaterial, Colour } from "./ConservatoryForm";
import { emptyPreviousPreviews, addConservatory } from "./../actions";

import "css/ConservatoryPage.css";

class ConservatoryPage extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.FormList = [Type, Size, Style, RoofMaterial, Colour];
        this.state = {
            page: 0
        };
    }

    componentDidMount() {
        this.props.emptyPreviousPreviews();
    }

    setConservatoryType(typeName) {
        let newState = {
            isConservatory: false,
            isConservatoryRoof: false,
            isOrangery: false
        };

        if (/conservatory/i.test(typeName))
            newState.isConservatory = true;

        if (/conservatory roof/i.test(typeName))
            newState.isConservatoryRoof = true;

        if(/orangery/i.test(typeName))
            newState.isOrangery = true;

        this.setState(newState);

        this.props.emptyPreviousPreviews();
    }

    nextPage() {
        this.setState({ page: this.state.page + 1 });
    }

    previousPage() {
        this.setState({ page: this.state.page - 1 });
    }

    changePage(newPage) {
        this.setState({ page: newPage });
    }

    handleSubmit(values) {
        // call action creator to create this item and go to summary
        this.props.addConservatory(values);

        this.props.history.push("/Summary");
    }

    render() {
        const { page } = this.state;

        let properties = {
            onSubmit: this.nextPage,
            previousPage: this.previousPage,
            setConservatoryType: this.setConservatoryType
        };

        if (page === 0) {
            delete properties.previousPage;
        }

        if (page === this.FormList.length - 1) {
            properties.onSubmit = this.handleSubmit.bind(this);
        } else {
            properties.onSubmit = this.nextPage;
        }

        let Step = this.FormList[page];

        window.dataLayer.push({
            event: "VirtualPageView",
            "VirtualPageURL": this.props.location.pathname + "/" + Step.name
        });

        return (
            <div className="ConservatoryPage">
                <Logo topLeft={true} hideTextOnSmall={true} />
                <Cart />
                <StepHistory StepList={this.FormList} StepIndex={page} onStepClick={this.changePage.bind(this)} />
                <ReactCSSTransitionReplace 
                    transitionName={"page"} 
                    transitionEnterTimeout={2000} 
                    transitionLeaveTimeout={1000}
                    className="transition-container">
                    <Step.form key={Step.name} {...properties} />
                </ReactCSSTransitionReplace>
            </div>
        );
    }
}

export default withRouter(connect(null, { addConservatory, emptyPreviousPreviews})(ConservatoryPage));



// WEBPACK FOOTER //
// ./src/containers/ConservatoryPage.js